<ng-container *ngIf="formReady$ | async">
    <div [formGroup]="form">
        <div class="form-input-label-2" [ngClass]="{ required: required }" [class.is-error]="form.controls.nif.invalid && form.controls.nif.dirty">
            <input
                name="nif"
                id="nif"
                class="form-control input"
                type="text"
                formControlName="nif"
                [placeholder]="'dev.forms.nif' | translate"
                [class.validation-error]="form.controls.nif.invalid && form.controls.nif.dirty"
            />
            <label for="nif">{{ 'dev.forms.nif' | translate }}</label>
            <div class="validation-error-wrap">
                <validation-error numErrors="1" [controlForm]="form.controls.nif" [errorMessageList]="errorMessageList"></validation-error>
            </div>
        </div>
    </div>
</ng-container>
